<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.selectedAll"
                  @change="changeSelectAll"
                  id="selectedAll"
                />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button
            type="button"
            class="dropdown-toggle dropdown-toggle-split btn"
            data-toggle="dropdown"
            aria-expanded="false"
            aria-haspopup="true"
          ></button>
          <div class="dropdown-menu">
            <button
              :disabled="actionData.model.listPlayListSelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('delete_list')"
              color="danger"
            >
              <CIcon name="cil-trash" style="danger" class="mr-2"/>
              Xóa tất cả
            </button>
          </div>
        </div>
      </CCol>
      <CCol xs="12" sm="4" md="3" lg="3" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker id="datepicker" v-model="dateRange" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol xs="12" sm="4" md="3" lg="3" xl="2">
        <BaseInput
          :options="titleInput.options"
          :data="titleInput.data"
          :listener="titleInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right; margin-left: 5px"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)"
            >
              <i class="fa fa-refresh"></i>&nbsp; Tải lại
            </CButton>
            <CButton
              style="float: right;"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="$router.push('/files-screen-management/play-list-add.html')"
            >
              <i class="fa fa-plus"></i>&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listPlayListSelectedId"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #type="{ item }">
            <td>
              <span v-if="item.type == -1" class="badge badge-secondary">Chữ chạy</span>
              <span v-else-if="item.type == 0" class="badge badge-secondary">Văn bản</span>
              <span v-else-if="item.type == 1" class="badge badge-secondary">Hình ảnh</span>
              <span v-else-if="item.type == 2" class="badge badge-secondary">Video</span>
              <span v-else-if="item.type == 4" class="badge badge-secondary">Tài liệu</span>
            </td>
          </template>
          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-if="item.createDate == null"></td>
          </template>
          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Cập nhật'"
                  square
                  size="sm"
                  @click="$router.push(`${item.id}/play-list-update.html`)"
                >
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="setupSelectOneAction('delete_one', item.id, item.name)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import {DatePicker} from "v-calendar";

export default {
  name: "PlayList",
  components: {
    BaseFormLoading,
    BaseSelect,
    BaseTable,
    BaseInput,
    DatePicker,
    ModalConfirm
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/play-list/deleteById",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "danh sách phát",
          that.actionData.model.playListSelectedName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.playListSelectedId,
        };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Xóa danh sách phát " + that.actionData.model.playListSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("delete_list", {
      url: "/play-list/delete-ids",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "các danh sách phát", "đã chọn");
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          lsId: that.actionData.model.listPlayListSelectedId
        };
      },
      successCallback: function () {
        that.actionData.model.listPlayListSelectedId = [];
        that.showSuccessMsg({message: "Xóa danh sách danh sách phát thành công"});
        that.loadDataMainTable();
      },
    });
    return {
      loading: {value: false},
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          playListSelectedId: null,
          playListSelectedName: null,
          listPlayListSelectedId: []
        }
      },
      dateRange: {
        start: that.$helper.subtractNowDate(30).setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      titleInput: {
        options: {
          placeholder: "Tên danh sách phát",
          label: "Tên danh sách phát",
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#"},
            {key: "index", label: "STT"},
            {key: "name", label: "Tên danh sách"},
            {key: "type", label: "Loại danh sách"},
            {key: "createDate", label: "Thời gian tạo"},
            {key: "action", label: "Thao tác"}
          ],
          slots: [
            "checkbox",
            "index",
            "type",
            "createDate",
            "action"
          ],
          pageSize: 15
        },
        dataSource: {
          url: "/play-list/getPages",
          dataSubmit: function () {
            // return that.$helper.setupDataSubmit(that.$data);
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDateDDMMYYYY(that.dateRange.start);
            params.toDate = that.$helper.formatDateDDMMYYYY(that.dateRange.end);
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    async viewFile(url) {
      let that = this;
      this.loading.value = true;
      const data = await this.$helper.blobFileByUrl(url);
      setTimeout(() => {
        that.loading.value = false;
        window.open(data);
      }, 500);
    },
    changeSelectAll: function (event) {
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listPlayListSelectedId = [];
        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listPlayListSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listPlayListSelectedId = [];
      }
    },
    setupSelectOneAction: function (actionTypeKey, playListSelectedId, playListSelectedName) {
      let actionData = this.actionData.model;
      actionData.playListSelectedId = playListSelectedId || null;
      actionData.playListSelectedName = playListSelectedName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date().setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    },
    "actionData.model.listPlayListSelectedId": function (newValue) {
      let that = this;
      if (newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
      } else {
        that.actionData.model.selectedAll = false;
      }
    }
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
